import React, { useEffect, useState } from "react";
import HoriBarChart from "../../../components/Charts/HorizontalBarChart";
import { Loader } from "rsuite";
import { axInstBasic } from "../../../components/Service/Service";

// Fetch API (token will be sent automatically via cookie)
const fetchRtoWiseChassis = async (isArn) => {
  try {
    // axInstBasic already has baseURL + Basic Auth + withCredentials
    const res = await axInstBasic.post("RtoWiseChassis", { isArn });

    return res.data?.result || [];
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw new Error("Failed to fetch RTO wise chassis data");
  }
};

export default function ChasisRegistered({ isArn }) {
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isArn) return; // Wait for ARN from parent/context

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const apiData = await fetchRtoWiseChassis(isArn);

        // Extract RTO buckets safely
        const buckets = apiData
          ?.map((item) => item?.Registered_rto?.buckets || [])
          .flat()
          .filter(
            (bucket) => bucket?.key && typeof bucket?.doc_count === "number"
          );

        setChartData(buckets || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [isArn]);

  // Loading UI
  if (loading) {
    return (
      <div className="grid place-items-center w-full h-full py-8">
        <Loader />
      </div>
    );
  }

  // Error UI
  if (error) {
    return <p className="text-red-500 text-center py-4">Error: {error}</p>;
  }

  // Empty data UI
  if (!chartData.length) {
    return (
      <p className="text-gray-500 text-center py-4">
        No data available to display.
      </p>
    );
  }

  // Prepare chart data
  const keyData = chartData.map((b) => b.key).reverse();
  const valData = chartData.map((b) => b.doc_count).reverse();

  return (
    <div className="p-2 relative">
      <HoriBarChart
        data={{ keyData, valData }}
        heading="RTO Wise Chassis Registered"
        top="20%"
        height="250px"
      />
    </div>
  );
}
